module.exports = __webpack_public_path__ + "media/day/293-930f4304.svg";